import { Box, Modal } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { ActivityTypes } from '../../../../../../constants/activity-types.enum';

function SlideDrawingResponse() {
    const activity = useSelector((state: any) => state.activity);
    const [drawingUrl, setDrawingUrl] = React.useState('');
    const [open, setOpen] = React.useState(false);

    const openImageModal = (response: any) => {
        setDrawingUrl(response.responseData);
        setOpen(true);
    };

    return (
        <>
            <div className="chat_text_group">
                {activity.activityProps.activityType === ActivityTypes.SLIDE_DRAWING &&
                    activity.submittedResponses.map((response: any, index: number) => (
                        <div className="chat_text slidedrawing " key={index}>
                            <img src={response.responseData} alt="logo" onClick={() => openImageModal(response)} />
                        </div>
                    ))}
            </div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="lightbox_modal"
            >
                <Box className="modal_main_container">
                    <div className="image_light_box">
                        <div className="big__content">
                            <img src={drawingUrl} alt="logo" />
                        </div>
                    </div>
                </Box>
            </Modal>
        </>
    );
}

export default SlideDrawingResponse;
